import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardingVesselsComponent } from './onboarding-vessels.component';
import { CargoHeatingDetailComponent } from './cargo-heating-detail/cargo-heating-detail.component';
import { EmissionDetailComponent } from './emission-detail/emission-detail.component';
import { CargoHeatingOnboardingDashboardComponent } from './cargo-heating-onboarding-dashboard/cargo-heating-onboarding-dashboard.component';
import { OnboardingEditableSectionComponent } from './onboarding-editable-section/onboarding-editable-section.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChartModule } from 'angular-highcharts';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { OnboardingVesselsRoutingModule } from './onboarding-vessels-routing.module';
import { AppBackButtonModule } from 'src/app/shared/components/app-back-button/app-back-button.module';
import { DynamicDataTableModule } from 'src/app/shared/components/dynamic-data-table/dynamic-data-table.module';
import { ChSectionDocumentComponent } from 'src/app/modules/Cargo_Heating_modules/shared/ch-section-document/ch-section-document.component';



@NgModule({
  declarations: [
    OnboardingVesselsComponent,
    CargoHeatingDetailComponent,
    EmissionDetailComponent,
    CargoHeatingOnboardingDashboardComponent,
    OnboardingEditableSectionComponent,
  ],
  imports: [
    CommonModule,
    MatPaginatorModule,
    MaterialModule,
      ReactiveFormsModule,
            MaterialModule,
            MatPaginatorModule,
            MatSortModule,
            MatProgressSpinnerModule,
            FormsModule,
            CustomDatePickerModule,
            CustomInputModule,
            CustomDropdownModule,
            ChartModule,
            MatDialogModule,
            AppBackButtonModule,
            DynamicDataTableModule,
            ChSectionDocumentComponent,
            OnboardingVesselsRoutingModule
  ],
  exports:[
    OnboardingVesselsComponent
  ]
})
export class OnboardingVesselsModule { }
